<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="table-demo">
      <vx-card title="List Hasil SWAB">
        <template slot="actions">
          <vs-button color="primary" type="filled" href="#" @click="activePromptPatient=true">Input Hasil SWAB Baru</vs-button>
        </template>
        <vs-table search pagination max-items="10" :data="listSwab" style="text-align:center;">
            <template slot="thead">
                <vs-th>Tgl Test</vs-th>
                <vs-th>No MR</vs-th>
                <vs-th>Nama Pasien</vs-th>
                <vs-th>Usia</vs-th>
                <vs-th>Jns Kelamin</vs-th>
                <vs-th>Lokasi</vs-th>
                <vs-th>Test Ke</vs-th>
                <vs-th>Hasil</vs-th>
                <!--
                <vs-th>&nbsp;</vs-th>
                -->
            </template>

            <template slot-scope="{data}">
                <vs-tr :state="tr.result=='NEGATIF'?'danger':null" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].testDate | formatDate}}
                    </vs-td>
                    <vs-td>
                        {{(data[indextr].patient?data[indextr].patient.patientNumber:'')}}
                    </vs-td>
                    <vs-td>
                        {{(data[indextr].patient?data[indextr].patient.name:'')}}
                    </vs-td>
                    <vs-td v-if="data[indextr].patient.iage!=null">
                        {{data[indextr].patient.iage}}
                    </vs-td>
                    <vs-td v-else>
                        {{data[indextr].patient.dob | formatAge}}
                    </vs-td>
                    <vs-td>
                        {{(data[indextr].patient?data[indextr].patient.gender:'')}}
                    </vs-td>
                    <vs-td>
                        {{(data[indextr].patient?data[indextr].patient.address:'')}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].num}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].swabResult}}
                    </vs-td>
                    <!--
                    <vs-td style="align-items: center; justify-content: center; display: flex;">
                      <div class="flex">
                        <vs-button class="mr-4" radius style="cursor: pointer;" @click="activePromptSwabClick(data[indextr].id)" color="warning" icon="fast_forward"></vs-button>
                        <vs-button radius style="cursor: pointer;" @click="openConfirm(data[indextr].id)" color="danger" icon="delete"></vs-button>
                      </div>
                    </vs-td>
                    -->
                </vs-tr>
            </template>
        </vs-table>

        <template slot="footer">
          <span class="flex">
            <vs-button radius color="danger" icon="circle" class="ml-6" style="width: 20px!important; height: 20px!important;"></vs-button>
            <span class="ml-4">: POSITIF </span>
          </span>
        </template>
      </vx-card>

     <vs-prompt class="w80"
        style="overflow: auto:"
       title="Input Hasil SWAB"
       @accept="acceptAlert"
       @cancel="cancelAlert"
       accept-text="Simpan"
       cancel-text="Batal"
       :active.sync="activePromptPatient">
         <div>
           <div class="vx-row">
             <div class="vx-col w-1/2 mt-2 mb-2 flex">
               <vx-card>
                 <div class="vx-row">
                   <div class="vx-col w-full mt-2 mb-2 flex">
                     <vs-select
                       autocomplete
                       class="w-full"
                       name="patient"
                       v-validate="'required'"
                       placeholder="Cari Pasien (No MR/Nama/Tgl Lahir/)"
                       v-model="patient"
                       @input-change="getListPatient"
                       @change="loadDataPatient"
                       >
                       <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in listPatient" />
                     </vs-select>
                   </div>
                   <div class="vx-col w-full mt-2 mb-2 flex">
                    <span class="text-danger text-sm" v-show="errors.has('patient')">{{ 'Nama Pasien tidak boleh kosong' }}</span>
                   </div>
                 </div>

                 <vs-divider position="center">
                  Data Pasien
                 </vs-divider>

                  <vs-row class="mt-4">
                    <vs-col class="w-full flex">
                       <vs-input disabled name="patientName" label="Nama Lengkap Pasien" class="w-1/2" v-model="patientName" />
                       <vs-input disabled name="patientMR" label="No MR" class="w-1/4 ml-4" v-model="patientMR" />
                       <vs-input disabled name="ward" label="Lokasi" class="w-1/4 ml-4" v-model="ward" />
                    </vs-col>
                  </vs-row>
                  <vs-row class="mt-4">
                    <vs-col class="w-1/4">
                       <label for="patientBirthdate" class="vs-input--label">Tgl Lahir</label>
                       <datepicker disabled class="w-3/4" name="patientBirthdate" format="dd-MMM-yyyy" v-model="patientBirthdate"></datepicker>
                    </vs-col>
                    <vs-col class="w-1/4 flex">
                       <vs-input disabled name="patientAge" label="Umur" v-model="patientAge" class="w-1/2" />
                       <label class="vs-input--label mt-8">Tahun</label>
                    </vs-col>
                    <vs-col class="w-1/2 flex">
                       <vs-radio disabled v-model="patientSex" vs-name="patientSex" vs-value="L" class="ml-6 mr-6 mt-6">Laki-Laki</vs-radio>
                       <vs-radio disabled v-model="patientSex" vs-name="patientSex" vs-value="P" class="ml-6 mt-6">Perempuan</vs-radio>
                    </vs-col>
                  </vs-row>
               </vx-card>
             </div>
             <div class="vx-col w-1/2 mt-2 mb-2 flex">
              <vx-card>
                <div class="vx-row">
                  <div class="vx-col w-1/3 mt-2 mb-2 flex">
                     <label for="testDate" class="vs-input--label vs-dialog-text">Tgl Test SWAB</label>
                  </div>
                  <div class="vx-col w-1/2 mt-2 mb-2 flex">
                     <datepicker class="w-full" name="testDate" format="dd-MMM-yyyy" v-model="testDate"></datepicker>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-1/3 mt-2 mb-2 flex">
                     <label for="labRef" class="vs-input--label vs-dialog-text">Lab Referensi</label>
                  </div>
                  <div class="vx-col w-2/3 mt-2 mb-2 flex">
                    <vs-select
                      autocomplete
                      class="w-full"
                      name="labRef"
                      v-validate="'required'"
                      placeholder="Pilih Lab Reference.."
                      v-model="labRef"
                      >
                      <vs-select-item :key="index" :value="item.id" :text="item.name+' ('+item.code+')'" v-for="(item,index) in listLabRef" />
                    </vs-select>
                  </div>
                  <div class="vx-col w-1/3 mt-2 mb-2 flex" v-if="errors.has('labRef')">&nbsp;</div>
                  <div class="vx-col w-2/3 mt-2 mb-2 flex">
                   <span class="text-danger text-sm" v-if="errors.has('labRef')">{{ 'Lab Reference harus diisi' }}</span>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-1/3 mt-2 mb-2 flex">
                     <label for="testSwabKe" class="vs-input--label vs-dialog-text">Test SWAB Ke</label>
                  </div>
                  <div class="vx-col w-1/4 mt-2 mb-2 flex">
                    <vs-select
                      autocomplete
                      class="w-full"
                      name="testSwabKe"
                      placeholder="Test SWAB Ke"
                      v-model="testSwabKe"
                      >
                      <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in ['1', '2', '3', '4', '5', '6']" />
                    </vs-select>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-1/3 mt-2 mb-2 flex">
                     <label for="resSwab" class="vs-input--label vs-dialog-text">Hasil Test SWAB</label>
                  </div>
                  <div class="vx-col w-1/2 mt-2 mb-2 flex">
                     <vs-radio v-model="resSwab" vs-name="resSwab" vs-value="Positive" class="mr-6">
                        <label style="font-weight:bold; color:red">POSITIF</label>
                     </vs-radio>
                     <vs-radio v-model="resSwab" vs-name="resSwab" vs-value="Negative" class="ml-6">NEGATIF</vs-radio>
                  </div>
                </div>
              </vx-card>
            </div>
           </div>
         </div>
      </vs-prompt>

    </div>
</template>

<script>
import axios from '@/axios.js';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  data() {
    return {
      idSelected: null,
      activePromptPatient:false,
      patient: '',
      patientName: '',
      patientMR: '',
      ward: '',
      patientBirthdate: null,
      patientAge: 0,
      patientSex: null,
      testDate: new Date(),
      labRef: null,
      testSwabKe: 1,
      resSwab: 'Negative',
      dataPatient: {},
      listPatient: [],
      listSwab: [],
      listLabRef: [
        {
          id: 1,
          code: 'BBLK',
          name: 'BBLK Jakarta',
        },
        {
          id: 2,
          code: 'RSPJ',
          name: 'RSPJ',
        },
        {
          id: 3,
          code: 'RSDC',
          name: 'RSDC Wisma Atlet',
        },
        {
          id: 4,
          code: 'FKUI',
          name: 'Mikro FKUI',
        },
        {
          id: 5,
          code: 'KALGEN',
          name: 'Kalgen',
        },
        {
          id: 7,
          code: 'EIJKMAN',
          name: 'Eijkman Institute for Molecular Biology',
        },
        {
          id: 8,
          code: 'BPOM',
          name: 'BPOM',
        }
      ]
    };
  },
  components: {
    Datepicker
  },
  methods: {
    openConfirm(id) {
        this.idSelected = id
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Confirm`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Hapus',
            cancelText: 'Batal',
            accept: this.deleteData
        })
    },
    deleteData() {

    },
    acceptAlert() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `Konfirmasi`,
              text: 'Simpan data ?',
              acceptText: 'Ya',
              cancelText: 'Tidak',
              accept: this.submitData
          });
        } else {
          // form have errors
          this.$vs.notify({
            title:'Error',
            time:4000,
            text:'Maaf, data tidak tersimpan, ada data mandatory yang harus diisi. Periksa kembali',
            color:'danger',
            position:'top-right'
          })
          this.activePromptPatient=true;
        }
      });
    },
    submitData() {
        var d = this.testDate,
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        var td = [year, month, day].join('-');

        let data = {
          patient: { id : this.patient},
          labReference: { id : this.labRef},
          testType: { id : 1},
          num: this.testSwabKe,
          testDate : td,
          swabResult : this.resSwab,
        }

        axios
            .post('/patient/visit/save', data)
            .then(response => {
                if (response.data.status) {
                  this.$vs.notify({
                    title:'Informasi',
                    time:4000,
                    text:'Data berhasil disimpan',
                    color:'success',
                    position:'top-right'
                  });

                  this.initialPatient();

                } else {
                  this.$vs.notify({
                    title:'Informasi',
                    time:4000,
                    text:'Data gagal disimpan',
                    color:'danger',
                    position:'top-right'
                  });
                }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => this.loading = false);

        // clear data
        this.cancelAlert();
    },
    cancelAlert() {
      // clear data
      this.patient='';
      this.patientName='';
      this.patientMR='';
      this.ward='';
      this.patientBirthdate=null;
      this.patientAge=0;
      this.patientSex=null;
      this.testDate= new Date();
      this.labRef= null;
      this.testSwabKe= 1;
      this.resSwab= 'Negative';
      this.listPatient = [];
    },
    activePromptSwabClick(id) {
      this.activePromptPatient=true;console.log(id)
      /*axios
          .get('/patient/list/swab?id='+id)
          .then(response => {
              //this.listSwab = response.data.data;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => this.loading = false);*/
    },
    loadDataPatient() {
      if (this.patient!='') {
        axios
            .get('/patient/get?id='+this.patient)
            .then(response => {
                if (response.data.data) {
                  var x = response.data.data[0];

                  this.patientName=x.name;
                  this.patientMR=x.patientNumber;
                  this.ward=x.address;
                  this.patientBirthdate=x.dob;
                  if (x.dob) {
                    this.patientAge=moment().diff(x.dob, 'years');
                  }
                  this.patientSex=x.genderId;
                }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => this.loading = false);
      }
    },
    getListPatient(event) {
      if (event.target.value.length > 2) {
        axios
            .get('/patient/list?keyword='+event.target.value)
            .then(response => {
                if (response.data.data) {
                  var y = []
                  response.data.data.forEach(function(i){
                    var x = {}
                    x.value = i.id;
                    x.text = i.name+' (no mr :'+i.patientNumber+')';

                    y.push(x)
                  });

                  this.listPatient = y;
                }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => this.loading = false);
      }
    },
    initialPatient() {
      axios
          .get('/patient/list/swab')
          .then(response => {
              this.listSwab = response.data.data;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => this.loading = false);
    }
  },
  computed: {

  },
  created() {
    this.initialPatient();
  }
};
</script>

<style lang="scss">
.w50 .vs-dialog {
    max-width:50%;
}

.w80 .vs-dialog {
    max-width:80%;
}
</style>
